"use client"
import Link from "next/link"
import { 
  COMPANY_INFO, 
  CONTACT_INFO, 
  LEGAL_LINKS 
} from "@/lib/constants"
import { navigateToContact } from "@/lib/scroll-utils"
import { Button } from "@/components/ui/button"
import { useDialog } from '@/contexts/dialog-context'
import { useSmoothScroll } from '@/hooks/useSmoothScroll'

export default function Footer() {
  const currentYear = new Date().getFullYear()
  const { openDialog } = useDialog()
  const { scrollToSection } = useSmoothScroll()
  
  return (
    <footer className="wrapper bg-background text-foreground py-small">
      <div className="max-w-screen-2xl mx-auto w-full">
        {/* Main Footer Grid */}
        <div className="flex flex-col lg:flex-row gap-2 lg:gap-12 w-full">
          
          {/* Brand & Description */}
          <div className="flex flex-col gap-4 w-full">
            <div className="space-y-0">
              <Link 
                href="/" 
                className="text-2xl font-semibold leading-4 text-foreground hover:text-foreground/80 transition-colors"
              >
                WeBuyYour<br></br>
                Watches.com
              </Link>
              <div className="w-26 h-[2px] bg-foreground/60"></div>
              <Link href="https://www.thewatchsection.com/" target="_blank" className="font-light text-sm">
              Part of The Watch Section
              </Link>
            </div>
            
            <p className="text-body text-foreground/70 leading-relaxed max-w-sm">
              {COMPANY_INFO.description}
            </p>
            {/* CTA Button */}
            <div className="lg:pt-4 flex justify-start gap-2">
              <Button 
                onClick={openDialog}
              >
                Get Quote Today
              </Button>

              <Button 
                variant="outline"
                onClick={navigateToContact}
              >
                Get In Touch
              </Button>
            </div>
            {/* Contact Information */}
          <div className="space-y-2 w-full">
            
            <div className="space-y-2 pt-8">
              {CONTACT_INFO.map((item, index) => {
                const Icon = item.icon
                return (
                  <div key={index} className="flex items-center gap-2 justify-start">
                    <Icon className="w-4 h-4 text-foreground/60 flex-shrink-0" />
                    <span className="text-sm text-foreground/70">{item.displayValue}</span>
                  </div>
                )
              })}
            </div>

            {/*}
            
            <div className="space-y-3">
              <div className="text-caption text-foreground/60">{COMPANY_INFO.credentials.accredited.toUpperCase()}</div>
              <div className="flex items-center gap-4">
                <div className="text-small text-foreground/80">{COMPANY_INFO.credentials.bbbRating}</div>
                <div className="w-px h-4 bg-background/40"></div>
                <div className="text-small text-foreground/80">{COMPANY_INFO.credentials.license}</div>
              </div>
            </div>
            */}
          </div>
          
          
          
            
            

          </div>
          {/* Empty space to push right columns to the edge */}
          <div className="hidden lg:block lg:col-span-2"></div>
          
          {/* Navigation */}
          <div className="flex flex-col justify-start space-y-4 text-left lg:text-right w-full pt-small lg:pt-0">
            <div className="space-y-2">
              <h3 className="text-2xl text-foreground">Navigation</h3>
            </div>
            <nav className="space-y-2">
              <button 
                onClick={() => scrollToSection('home', { targetPage: '/', offset: -120 })}
                className="block text-body text-foreground/70 hover:text-foreground transition-colors text-left lg:text-right w-full"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('our-process', { targetPage: '/', offset: -120 })}
                className="block text-body text-foreground/70 hover:text-foreground transition-colors text-left lg:text-right w-full"
              >
                How it Works
              </button>
              <button 
                onClick={() => scrollToSection('testimonials', { targetPage: '/', offset: -120 })}
                className="block text-body text-foreground/70 hover:text-foreground transition-colors text-left lg:text-right w-full"
              >
                Testimonials
              </button>
              <Link 
                href="/contact"
                className="block text-body text-foreground/70 hover:text-foreground transition-colors text-left lg:text-right w-full"
              >
                Contact
              </Link>
              <button 
                onClick={openDialog}
                className="block text-body text-foreground/70 hover:text-foreground transition-colors text-left lg:text-right w-full"
              >
                Sell Your Watch
              </button>
            </nav>
          </div>
          
          
          
        </div>
        
        {/* Divider */}
        <div className="mt-8 mb-4 h-px bg-foreground/20"></div>
        
        {/* Bottom Bar */}
        <div className="flex flex-col lg:flex-row gap-2 lg:gap-6 items-center lg:justify-between">
          <div className="space-y-2 lg:space-y-0">
            <p className="text-small text-foreground/60">
              © {currentYear} {COMPANY_INFO.name}. All rights reserved.
            </p>
            
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 lg:justify-end">
            <nav className="flex flex-wrap gap-4 sm:gap-6">
              {LEGAL_LINKS.map((link, index) => (
                <Link 
                  key={index}
                  href={link.href}
                  className="text-small text-foreground/60 hover:text-foreground/80 transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>
        <div className="flex justify-center lg:justify-start pt-2">

            <Link href="https://www.arasolutions.dev" target="_blank" className="text-small text-foreground/60 hover:text-foreground/80 transition-colors">
                Created by Ara
            </Link>
        </div>
        
      </div>
    </footer>
  )
}
